// Feature gating for the club Education workspace surfaces

export function isPathwaysChartFeatureEnabled(): boolean {
  const runtimeOverride = (globalThis as { __PATHWAYS_CHART_FLAG__?: unknown }).__PATHWAYS_CHART_FLAG__;
  if (runtimeOverride !== undefined) {
    return Boolean(runtimeOverride);
  }

  return String(import.meta.env.VITE_PATHWAYS_CHART ?? "true").toLowerCase() === "true";
}

export function isEducationTabEnabledForClub(
  options: {
    clubId?: number | null;
    isOfficer?: boolean;
    isAdmin?: boolean;
  } = {},
): boolean {
  if (!isPathwaysChartFeatureEnabled()) return false;
  if (options.isAdmin) return true;
  return Boolean(options.isOfficer && options.clubId);
}
